module.exports = __webpack_public_path__ + "static/media/logo130.723bdb9f.png";